import { FIELD_TYPES } from "constants/template-field-type";
const imageFields = {
    src: {
        type: FIELD_TYPES.GALLERY,
        label: "Image"
    },
    alt: {
        type: FIELD_TYPES.TEXT,
        label: "Image alt",
        translatable: true
    }
};
const storyConfig = {
    type: FIELD_TYPES.NESTED,
    label: "Story",
    fields: {
        type: {
            type: FIELD_TYPES.COMBO,
            label: "Story type",
            options: [
                {
                    value: "quote",
                    text: "Quote"
                },
                {
                    value: "stat",
                    text: "Stat"
                }
            ]
        },
        image: {
            type: FIELD_TYPES.NESTED,
            label: "Customer image",
            fields: imageFields
        },
        backgroundColor: {
            type: FIELD_TYPES.TEXT,
            label: "Card background color (hex, optional)"
        },
        textColor: {
            type: FIELD_TYPES.TEXT,
            label: "Text color (hex, optional)"
        },
        quoteColor: {
            type: FIELD_TYPES.TEXT,
            label: "Quote color (hex, applies to quote icon and bold text in quote)"
        },
        quote: {
            type: FIELD_TYPES.TEXT,
            label: "Quote text (only for type=quote, supports HTML)",
            textArea: true,
            translatable: true
        },
        author: {
            type: FIELD_TYPES.TEXT,
            label: "Author name (only for type=quote)",
            translatable: true
        },
        role: {
            type: FIELD_TYPES.TEXT,
            label: "Author role (only for type=quote)",
            translatable: true
        },
        statValue: {
            type: FIELD_TYPES.TEXT,
            label: "Stat value (only for type=stat, e.g. $118K)",
            translatable: true
        },
        statLabel: {
            type: FIELD_TYPES.TEXT,
            label: "Stat label (only for type=stat, e.g. saved per month)",
            translatable: true
        },
        industry: {
            type: FIELD_TYPES.TEXT,
            label: "Industry tag (only for type=stat)",
            translatable: true
        },
        industryTagColor: {
            type: FIELD_TYPES.TEXT,
            label: "Industry tag background color (hex, e.g. #DED4FC)"
        },
        industryTagTextColor: {
            type: FIELD_TYPES.TEXT,
            label: "Industry tag text color (hex, default #000000)"
        },
        ctaText: {
            type: FIELD_TYPES.TEXT,
            label: "CTA text (only for type=stat, e.g. Read the case study >)",
            translatable: true
        },
        ctaHref: {
            type: FIELD_TYPES.TEXT,
            label: "CTA link (only for type=stat, optional)"
        }
    }
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "Customer Stories Carousel",
    fields: {
        title: {
            type: FIELD_TYPES.TEXT,
            label: "Section title (supports HTML, e.g. <br>)",
            translatable: true
        },
        theme: {
            type: FIELD_TYPES.COMBO,
            label: "Background theme",
            options: [
                {
                    value: "light",
                    text: "Light"
                },
                {
                    value: "dark",
                    text: "Dark"
                }
            ]
        },
        withGetStarted: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Show header CTA button (unchecked replaces it with the prev/next arrows)"
        },
        ctaText: {
            type: FIELD_TYPES.TEXT,
            label: "Header CTA button text (e.g. Get started) — only used when \"Show header CTA button\" is checked",
            translatable: true
        },
        stories: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Stories",
            nestedConfig: storyConfig
        }
    }
};
